import * as React from "react";
import { ArrowRight, Settings } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function PrecisionEngineeringHub() {
  return <section data-section-id="224631" id="hero" className="relative w-full min-h-[90vh] flex items-center bg-background overflow-hidden">
      {}
      <style>{`
        @keyframes backgroundScroll {
          0% { background-position: 0 0; }
          100% { background-position: 48px 48px; }
        }
        .bg-grid-pattern {
          background-image: 
            linear-gradient(to right, hsl(0 0% 10% / 0.03) 1px, transparent 1px),
            linear-gradient(to bottom, hsl(0 0% 10% / 0.03) 1px, transparent 1px);
          background-size: 48px 48px;
          animation: backgroundScroll 60s linear infinite;
        }
        @keyframes slideUp {
          from { transform: translateY(20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .animate-slide-up {
          animation: slideUp 0.8s ease-out forwards;
        }
      `}</style>

      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-grid-pattern [mask-image:radial-gradient(ellipse_80%_60%_at_50%_50%,#000_40%,transparent_100%)] opacity-50" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6 py-16 lg:py-24 flex flex-col lg:flex-row items-center gap-12 lg:gap-8 animate-slide-up">
        
        {}
        <div className="flex-1 lg:w-[60%] flex flex-col gap-6 text-center lg:text-left">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-muted border border-border w-fit mx-auto lg:mx-0">
            <Settings className="size-4 text-primary animate-[spin_8s_linear_infinite]" />
            <span className="text-xs font-semibold tracking-wider uppercase text-muted-foreground font-default">
              Marketing de Performance
            </span>
          </div>
          
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-[4rem] font-bold tracking-tighter text-foreground font-default leading-[1.1]">
            Tráfego pago para empresas que <br className="hidden sm:block" />
            <span className="text-primary">
              querem gerar clientes
            </span>
          </h1>
          
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto lg:mx-0 font-default leading-relaxed">
            Estratégias personalizadas de anúncios online focadas em ROI. Transformamos cliques em faturamento real através de análise de dados e otimização contínua de campanhas.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center gap-4 mt-4 justify-center lg:justify-start">
            <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 border-none shadow-lg shadow-primary/20 h-12 px-8 text-base rounded-full">
              <Link to="https://wa.me/5511969100007">
                Falar com Especialista
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto h-12 px-8 text-base border-border hover:bg-accent hover:text-accent-foreground rounded-full">
              <Link to="/ServicesPage">
                Nossos Serviços
              </Link>
            </Button>
          </div>
          
          <div className="mt-8 flex items-center justify-center lg:justify-start gap-8 text-sm font-medium text-muted-foreground">
            <div className="flex items-center gap-2">
              <div className="size-2 rounded-full bg-primary" />
              Foco em Conversão
            </div>
            <div className="flex items-center gap-2">
              <div className="size-2 rounded-full bg-primary" />
              Gestão de Dados
            </div>
          </div>
        </div>

        {}
        <div className="w-full lg:w-[40%] flex justify-center items-center relative mt-12 lg:mt-0">
          {}
          <div className="absolute inset-0 bg-primary/5 blur-[100px] rounded-full -z-10 w-3/4 h-3/4 m-auto" />
          
          <div className="relative w-full max-w-[400px] lg:max-w-[500px] aspect-square">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/performance_growth_graph.png" alt="Gráfico de crescimento de performance digital" className="w-full h-full object-contain drop-shadow-xl opacity-90" />
            
            {}
            <div className="absolute top-10 right-10 bg-background/80 backdrop-blur-sm border border-border px-3 py-1.5 rounded-md shadow-sm hidden md:block">
              <p className="text-xs font-mono text-foreground">ROI: <span className="text-primary font-bold">+450%</span></p>
            </div>
            <div className="absolute bottom-10 left-10 bg-background/80 backdrop-blur-sm border border-border px-3 py-1.5 rounded-md shadow-sm hidden md:block">
              <p className="text-xs font-mono text-foreground">Status: <span className="text-primary font-bold">Escalando</span></p>
            </div>
          </div>
        </div>

      </div>
    </section>;
}